import $ from 'jquery'

/**
 * Manages UI updates for the comparison widget
 */
export class UIManager {
  constructor(targets, values) {
    this.targets = targets
    this.values = values
  }

  updateCounter(count) {
    if (this.targets.hasCounterTarget) {
      this.targets.counterTarget.textContent = `[${count} / 5]`
    }
  }

  updateButtonStates(count) {
    this.updateCompareButton(count)
    this.updateTextVisibility(count)
    this.updateCheckboxStates(count)
  }

  updateCompareButton(count) {
    const shouldEnable = count >= this.values.disableLimitValue
    
    if (this.targets.hasCompareButtonTarget) {
      if (shouldEnable) {
        this.targets.compareButtonTarget.removeAttribute('disabled')
      } else {
        this.targets.compareButtonTarget.setAttribute('disabled', true)
      }
    }
    
    if (this.targets.hasCompareButtonLabelTarget) {
      if (shouldEnable) {
        this.targets.compareButtonLabelTarget.classList.remove('disabled')
      } else {
        this.targets.compareButtonLabelTarget.classList.add('disabled')
      }
    }
  }

  updateTextVisibility(count) {
    const showButtons = count >= this.values.minimumCountValue
    
    if (this.targets.hasButtonGroupTarget) {
      if (showButtons) {
        this.targets.buttonGroupTarget.classList.remove('hide')
      } else {
        this.targets.buttonGroupTarget.classList.add('hide')
      }
    }
    
    if (this.targets.hasTwoItemTextTarget) {
      if (showButtons) {
        this.targets.twoItemTextTarget.classList.add('hide')
      } else {
        this.targets.twoItemTextTarget.classList.remove('hide')
      }
    }
  }

  updateCheckboxStates(count) {
    if (count >= this.values.maxCountValue) {
      $('[type="checkbox"]:not(:checked) + label').attr('disabled', true)
      $('[type="checkbox"]:not(:checked) + label').addClass('disabled')
    } else {
      $('[type="checkbox"] + label').removeClass('disabled')
      $('[type="checkbox"] + label').removeAttr('disabled')
    }
  }

  toggleWidget() {
    if (this.targets.hasWidgetTarget) {
      this.targets.widgetTarget.classList.toggle('slide-up-compare')
    }
  }

  createCompareElement(id, image, description) {
    return $(`<div class="col-md-2 margin-bottom-15 compare-product ${id}">
      <img class="img-compare image-border justify-content-center margin-top-15" src="${image}" alt="${description}">
      <button type="button" class="btn btn-danger btn-sm w-100 d-flex align-items-center justify-content-center gap-1 mt-2" 
        data-action="click->comparison-widget#removeProduct" 
        data-product-id="${id}" 
        data-product-image="${image}" 
        data-product-description="${description}">
        <i class="bi bi-x-circle"></i> Remove
      </button>
    </div>`)
  }

  addCompareElement($element, container) {
    $element.hide().appendTo(container).show('normal')
  }

  removeAllCompareProducts() {
    $('.compare-product').remove()
  }

  uncheckCheckbox(id) {
    $(`input[name="compare[]"][value="${id}"]`).prop('checked', false)
  }

  checkCheckbox(id) {
    $(`input[name="compare[]"][value="${id}"]`).prop('checked', true)
  }

  uncheckAllCheckboxes() {
    $('input:checkbox:checked').prop('checked', false)
  }

  updateHiddenField(value) {
    if (this.targets.hasHiddenFieldTarget) {
      const stringValue = Array.isArray(value) ? value.join(',') : value
      this.targets.hiddenFieldTarget.value = stringValue
    }
  }

  getProductCount() {
    return $('.compare-product').length
  }
}
